export default "__VITE_ASSET__CM2kN4eP__"